import { ERROR_COLORS, GRAY_COLORS, WARNING_COLORS } from 'asterX-UIkit'
import {
  CANCEL_STATUS,
  DECLINED_STATUS,
  EXECUTED_STATUS,
  IN_PROGRESS_STATUS,
  NEW_STATUS,
  NEED_REVISION_STATUS
} from 'constants/statuses'

export const tableStatusBtns = [
  {
    label: 'Все',
    code: [
      NEW_STATUS,
      IN_PROGRESS_STATUS,
      EXECUTED_STATUS,
      CANCEL_STATUS,
      DECLINED_STATUS,
      NEED_REVISION_STATUS
    ]
  },
  {
    label: 'Новые',
    code: [NEW_STATUS]
  },
  {
    label: 'В работе',
    code: [IN_PROGRESS_STATUS]
  },
  {
    label: 'Завершенные',
    code: [EXECUTED_STATUS]
  },
  {
    label: 'Отмененные',
    code: [CANCEL_STATUS, DECLINED_STATUS]
  }
]

export const getNotification = (status, unAnswered, hadQuestionnaire) => {
  if (unAnswered && status === 'В работе') {
    return {
      text: 'Вам пришло новое сообщение',
      color: ERROR_COLORS[700],
      backgroundColor: ERROR_COLORS[50],
      border: `1px solid ${ERROR_COLORS[200]}`
    }
  } else if (status === 'Завершен') {
    if (hadQuestionnaire) {
      return {
        text: 'Вы оставили отзыв',
        color: GRAY_COLORS[700],
        border: `1px solid ${GRAY_COLORS[300]}`,
        backgroundColor: GRAY_COLORS[50]
      }
    } else {
      return {
        text: 'Оставьте отзыв',
        color: WARNING_COLORS[600],
        backgroundColor: WARNING_COLORS[50],
        border: `1px solid ${WARNING_COLORS[200]}`
      }
    }
  } else {
    return {
      text: 'Перейти к сообщениям',
      color: GRAY_COLORS[700],
      border: `1px solid ${GRAY_COLORS[300]}`,
      backgroundColor: GRAY_COLORS[50]
    }
  }
}
